export default "__VITE_ASSET__DYFLCfLu__"